import React, {useState, useEffect, useRef} from 'react';
import { green } from 'config/colors';





export default function({value, onChange, style, ...props}) {
  
  const val = useRef(value);
  const container = useRef();
  const [display, setDisplay] = useState(value);
  
  useEffect(() => {
    const $el = container.current;
    
    const grab = e => {
      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', release);
      move(e);
    };
    
    const release = () => {
      document.removeEventListener('mousemove', move);
      document.removeEventListener('mouseup', release);
      onChange(val.current);
    };
    
    const move = e => {
      e.preventDefault();
      const x = e.clientX - $el.getBoundingClientRect().x;
      const w = $el.scrollWidth;
      val.current = Math.min(1, Math.max(0, x/w));
      setDisplay(val.current);
    };
    
    $el.addEventListener('mousedown', grab);
    return () => {
      $el.removeEventListener('mousedown', grab);
    };
    
  }, [container, val, setDisplay, onChange]);
  
  
  return (
    <div 
      ref={container}
      style={{
        position: 'relative',
        height: 8,
        padding: "8px 0",
        cursor: 'pointer',
        ...style,
      }}
      {...props}>
      
      <div 
        style={{
          backgroundColor: `rgba(0,0,0,0.2)`,
          boxShadow: 'inset 0 0 2px rgba(0,0,0,0.2)',
          height: 8,
        }}
      />
      
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: `${display * 100}%`,
          transform: 'translateX(-12px)',
          width: 24,
          height: 24,
          borderRadius: 12,
          backgroundColor: green,
          boxShadow: "0 2px 2px rgba(0,0,0,0.3)",
        }}
      />
      
    </div>
  );
}